import { FeedbackSection } from "@/components/FeedbackSection";
import { useAuth } from "@/context/AuthContext";

export default function Feedback() {
  const { user } = useAuth();
  return (
    <div>
      <div className="mb-8">
        <div className="overline mb-2">Your Experience</div>
        <h1 className="font-dash text-3xl">Share Your Feedback</h1>
        <p className="text-zinc-500 mt-2 text-sm">We welcome your reflections on your mediation with Tactis. Your feedback is confidential and reviewed personally.</p>
      </div>
      <div className="max-w-2xl">
        <FeedbackSection embedded defaultName={user?.full_name || ""} defaultEmail={user?.email || ""} />
      </div>
    </div>
  );
}
